<template>
	<v-container fluid>

		<v-row class="justify-center">
			<v-col cols="12" class="my-0 py-0">

				<v-row v-if="$store.getters.simpleSearch" class="justify-center pt-2">
					<v-col cols="6" class="my-0 py-0 pt-8">
						<v-card class="elevation-6" style="background: #11254d;background: linear-gradient(90deg,rgba(17, 37, 77, 1) 0%, rgba(17, 113, 112, 1) 50%, rgba(21, 168, 147, 1) 100%);">

							<v-row class="px-0 py-0 mx-1 " justify="start">
								<v-col style="max-height: 75px" cols="3" class="col-class">
									<v-icon color="#DBDBDB" large>mdi-database-search-outline</v-icon>
									<p style="color: #DBDBDB">Αναζήτηση</p>
								</v-col>

								<v-col style="max-height: 75px" cols="8" class="col-class pt-4 pl-2">
									<v-text-field :loading="$store.getters.loadingPublishers" :disabled="$store.getters.loadingPublishers" loader-height="3" dense class="text-white light-grey-outline" color="#DBDBDB" aria-label="search" @
												  v-model="singleSearch" outlined @keyup.enter="simpleSearchButtonTop">

									</v-text-field>
								</v-col>
							</v-row>
						</v-card>

					</v-col>
				</v-row>

				<v-row v-else class="justify-center pt-2">
					<v-col cols="10" class="my-0 py-0 pt-4">
<!--						advanced search filters-->
						<v-card>
							<v-form ref="form" class="mr-1 ml-1">
								<v-row class="pt-2">
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Τίτλος" dense v-model="criteria.title"
													  outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Υπότιτλος" dense v-model="criteria.subtitle"
													  outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Κωδικός Βιβλίου" v-model="criteria.id"
													  dense outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Συγγραφείς" dense v-model="criteria.authors"
													  outlined/>
									</v-col>
								</v-row>

								<v-row>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Αριθμός Έκδοσης" v-model="criteria.editionNumber"
													  dense outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Έτος Τρέχ. Έκδοσης" v-model="criteria.publicationYear"
													  dense outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Τίτλος τόμου" dense v-model="criteria.volumeTitle"
													  outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Αριθμός τόμου" dense v-model="criteria.volumeNumber"
													  outlined/>
									</v-col>
								</v-row>

								<v-row>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Λέξεις κλειδιά" dense v-model="criteria.keywords"
													  outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="ISBN" dense v-model="criteria.isbn"
													  outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-autocomplete class="primary-outline compact-field" label="Διαθέτης (Εκδότης)" :items="$store.getters.publishersForSelector.publisherList"
														dense outlined :loading="$store.getters.loadingPublishers" :disabled="$store.getters.loadingPublishers"
														item-value="id" item-text="name" v-model="criteria.publisherId"/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Εκδόσεις" dense v-model="criteria.editorialHouse"
													  outlined/>
									</v-col>
								</v-row>

								<v-row>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-select class="primary-outline compact-field" :items="typeSelector" dense
												  clearable v-model="criteria.type"
												  label="Τύπος" item-text="label" item-value="value"
												  @click:clear="criteria.type=null" outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-select class="primary-outline compact-field" v-model="criteria.finalizedByPublisher"
												  :items="finalizedByPublisherSelector" clearable dense
												  item-text="label" item-value="value" label="Ολοκληρωμένη Εγγραφή"
												  @click:clear="criteria.finalizedByPublisher=null" outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-row justify="space-between">
											<v-col class="my-1 py-0 pb-2" cols="5">
												<v-btn @click="resetForm" block small outlined class="mt-2"
													   color="primary">Επαναφορά
													<v-icon>mdi-refresh</v-icon>
												</v-btn>
											</v-col>
											<v-col class="my-1 py-0 pb-2" cols="5">
												<v-btn @click="advancedSearchButton" block small outlined class="mt-2"
													   color="secondary">Αναζήτηση
													<v-icon>mdi-database-search-outline</v-icon>
												</v-btn>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-form>
						</v-card>
					</v-col>
				</v-row>

				<!--				image that covers the page when no results -->
				<v-row class="justify-center pt-8" v-if="searchResults.length===0 && afterFirstSearch===false">
					<div class="mt-2" >
						<v-img :src="require('../assets/Eudoxus_Logo_RGB_Gr_Resize.png')"
							   style=" max-height:650px; max-width:650px;min-height:650px; min-width:650px" contain
							   alt=""></v-img>
					</div>
				</v-row>
				<v-row class="justify-center pt-8" v-if="searchResults.length===0 && afterFirstSearch===true">
					<div class="mt-2" >
						<h2 style="color: #DBDBDB">Δεν βρέθηκαν αποτελέσματα</h2>
					</div>
				</v-row>

<!--				main result space -->
				<v-row class="justify-center pt-8" v-if="searchResults.length>0 && afterFirstSearch===true">
					<v-col xl="2" lg="2" md="3" sm="4" v-if=" searchResults.length>0 || afterFirstSearch">
						<v-card style="opacity: 0.8;">
							<v-card-title class="py-0 my-0 mb-4 ">
								<v-row justify="center">
									<v-col class="mt-2" lg="6"  md="12" sm="12">
										<v-btn outlined color="primary" small rounded @click="resetSideSearch">
											καθαρισμός
											<v-icon color="primary"> mdi-broom</v-icon>
										</v-btn>
									</v-col>
									<v-col class="mt-2" lg="6" md="12" sm="12">
										<v-btn color="primary" @click="simpleSearchButtonSideMenu" rounded small>
											εφαρμογή
											<v-icon color="white"> mdi-check</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-card-title>
							<v-divider/>
							<v-card-text style="background-color: white; min-height: 900px">
								<v-form ref="sideSearch">
									<v-row class="py-0 my-0 mb-4 ">
										<v-icon color="primary">mdi-counter</v-icon>
										<strong style="color: #11254d" class="ml-1 ">Αριθμός Σελίδων</strong>

										<v-row align="center" class="mt-2">
											<v-col style="max-height: 30px" cols="4" class="py-0">
												<v-text-field
														v-model="pages[0]"
														outlined
														dense style="border-radius:12px"
														hide-details hide-spin-buttons
														single-line class="primary-outline compact-field"
														type="number"
												></v-text-field>
											</v-col>

											<!-- Max -->
											<v-col style="max-height: 30px" cols="4" class="py-0">
												<v-text-field
														v-model="pages[1]"
														outlined
														dense style="border-radius:12px"
														hide-details hide-spin-buttons
														single-line class="primary-outline compact-field"
														type="number"
												></v-text-field>
											</v-col>

											<!-- Arrow -->
											<v-col style="max-height: 30px" cols="2" class="py-0 mb-1 px-0 mx-0">
												<v-btn v-if="!pagesSelected"  fab outlined x-small @click="pagesSelected=true">
													<v-icon>mdi-check</v-icon>
												</v-btn>
												<v-btn v-else fab color="primary" x-small @click="pagesSelected=!pagesSelected">
													<v-icon color="white">mdi-check-all</v-icon>
												</v-btn>
											</v-col>

										</v-row>

										<!-- Slider -->
										<v-range-slider
												v-model="pages"
												:min="1"
												:max="3500"
												step="1"
												hide-details
												class="mt-4"
										></v-range-slider>
									</v-row>


									<v-row>
										<v-icon color="primary">verified</v-icon>
										<strong style="color: #11254d" class="ml-1">Ολοκλ. Εγγραφή</strong>
									</v-row>
									<v-row >

										<v-chip-group @change="document.activeElement.blur()"
												v-model="finalisedByPublisherFacetSelect"  style="background-color: transparent !important;"
												color="primary" active-class="secondary">

											<v-chip outlined value="true" small style=" border-width: 2px !important;background-color: transparent !important;" color="primary">
												Ναι ( {{finalisedFacetResultTrue}} )
											</v-chip>

											<v-chip outlined value="false" small style=" border-width: 2px !important;background-color: transparent !important;" color="primary">
												Όχι ( {{finalisedFacetResultFalse}} )
											</v-chip>


										</v-chip-group>
									</v-row>

									<v-row>
										<v-icon color="primary">mdi-power</v-icon>
										<strong style="color: #11254d" class="ml-1">Ενεργό</strong>
									</v-row>
									<v-row >
										<v-chip-group @change="document.activeElement.blur()"
												v-model="activeFacetSelect"  style="background-color: transparent !important;"
												color="primary" active-class="secondary">

											<v-chip outlined value="true" small style=" border-width: 2px !important;background-color: transparent !important;" color="primary">
												Ναι ( {{activeFacetResultTrue}} )
											</v-chip>

											<v-chip outlined value="false" small style=" border-width: 2px !important;background-color: transparent !important;" color="primary">
												Όχι ( {{activeFacetResultFalse}} )
											</v-chip>


										</v-chip-group>
									</v-row>


									<v-row>
										<v-icon color="primary">mdi-book-open-variant-outline</v-icon>
										<strong style="color: #11254d" class="ml-1 mt-1">Τύπος βιβλίου</strong>
									</v-row>
									<v-row >
										<v-list class="checkbox-list" dense>
											<v-list-item
													v-for="(facet, index) in bookTypeFacets"
													:key="facet.key">
												<v-checkbox
														v-model="selectedBookTypeFromFacets"
														:label="bookTypeValues[facet.key] + ' (' + facet.value + ')'"
														:value="facet.key"
														hide-details/>
											</v-list-item>
										</v-list>

									</v-row>

									<v-row class="pt-2">
										<v-icon color="primary">mdi-calendar-badge-outline</v-icon>
										<strong style="color: #11254d" class="ml-1 ">Έτος τρέχουσας έκδοσης</strong>
									</v-row>
									<v-row>
										<v-list class="checkbox-list" dense>
											<v-list-item
													v-for="(facet, index) in publicationYearFacets"
													:key="facet.key">
												<v-checkbox
														v-model="selectedPublicationYearFromFacets"
														:label="facet.key + ' (' + facet.value + ')'"
														:value="facet.key"
														hide-details/>
											</v-list-item>
										</v-list>
									</v-row>


									<v-row class="pt-2">
										<v-icon color="primary">mdi-account-edit</v-icon>
										<strong style="color: #11254d" class="ml-1 ">Εκδόσεις</strong>
									</v-row>
									<v-row>
										<v-col cols="12" style="max-height: 35px">
											<v-autocomplete
													v-model="selectedPublisherIdFromFacets"
													:items="publisherIdFacetForSelect"
													item-text="label"
													item-value="key"
													multiple chips clearable
													hide-details dense outlined>

												<template v-slot:item="{ item }">
													<v-chip @click="" small outlined color="primary" class="text-truncate"
															style="max-width: 75ch; text-align: left; text-wrap: normal">
														{{item.label}}
													</v-chip>
												</template>
												<template v-slot:selection="{ item, index }">

													<span v-if="index === 0"></span>
													<span v-if="index === 1" class="black--text text-caption">{{ selectedPublisherIdFromFacets.length }}  επιλογές</span>

												</template>
											</v-autocomplete>

											<!--											<v-list  class="checkbox-list" dense  >-->
<!--												<v-list-item-->
<!--													v-for="(facet, index) in publisherIdFacet"-->
<!--													:key="facet.key">-->
<!--													<v-checkbox-->
<!--														v-model="selectedPublisherIdFromFacets"-->
<!--														:label="$store.getters.publishersForSelector.publisherMap[facet.key] + ' (' + facet.value + ')'"-->
<!--														:value="facet.key"-->
<!--														hide-details/>-->
<!--												</v-list-item>-->
<!--											</v-list>-->
										</v-col>
									</v-row>
								</v-form>
							</v-card-text>
						</v-card>
					</v-col>

					<!--					results col-->
					<v-col xl="10" lg="10" md="8" sm="8">

						<SearchResults :search-results="searchResults" :image-cache="imageCache"/>

						<v-row justify="center" v-if="searchResults.length>0" class="mb-2">
							<div class="text-center">
								<v-pagination v-model="page"
											  :length="totalPages"
											  total-visible="10"
								></v-pagination>
							</div>
						</v-row>
					</v-col>


				</v-row>

			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import requests from "../requests";
	import BookInfoDialog from "./BookInfoDialog";
	import utils from "../utilities"
	import SearchResults from "./SearchResults";

	export default {
		name: "SimpleSearch",
		components: {SearchResults, BookInfoDialog},
		data: () => ({
			updateFacets:true,
			afterFirstSearch:false,
			noResults:false,
			singleSearch: '',
            page:1,
			totalPages:0,
			pages: [1, 3500], // default range
			pagesSelected:false,
			bookTypeFacets:[],
			selectedBookTypeFromFacets:[],
			publicationYearFacets:[],
			publisherIdFacet:[],
			selectedPublisherIdFromFacets:[],
			selectedPublicationYearFromFacets:[],

			finalisedFacetResultTrue:'-',
			finalisedFacetResultFalse:'-',
			finalisedByPublisherFacetSelect:null,

			activeFacetResultTrue:'-',
			activeFacetResultFalse:'-',
			activeFacetSelect:null,

			finalizedByPublisherSelector: [
				{label: 'Ολοκληρωμένη', value: true},
				{label: 'Εκκρεμής', value: false}
			],
			typeSelector: [
				{label: 'Σύγγραμμα', value: 'Published'},
				{label: 'Ηλεκτρονικό Βιβλίο', value: 'eBook'},
				{label: 'Δωρεάν Ηλεκτρονικό Βοήθημα / Σημειώσεις', value: 'ProfessorNotes'}
			],
			bookTypeValues: {
				'published': 'Σύγγραμμα',
				'ebook': 'Ηλεκτρονικό Βιβλίο',
				'professornote': 'Δωρεάν Ηλεκτρονικό Βοήθημα / Σημειώσεις',
			},
			searchResults: [],
			defaultCover: require('../assets/blank.png'),
            imageCache:{},
		}),

		computed: {
			publisherIdFacetForSelect() {
				const map = this.$store.getters.publishersForSelector.publisherMap;

				return this.publisherIdFacet.map(f => ({
					key: Number(f.key),
					label: '(' + f.value + ') ' + map[f.key]
				}));
			},
		},

		methods: {

			test(){
				console.log(this.pages);
				console.log(this.pagesSelected);
			},

			simpleSearchButtonTop(fromTopButton) {
				// here we set page to 1 , also top search should reset side search and always update facets
				// side search still sets page to 1 but avoids updating the facets
				this.page = 1;
				this.updateFacets = true;

				this.resetSideSearch();

				this.simpleSearch(fromTopButton);
			},

			simpleSearchButtonSideMenu(fromTopButton) {
				// here we set page to 1 ,
				// side search still sets page to 1 but avoids updating the facets
				this.page = 1;
				this.updateFacets = true;


				this.simpleSearch(fromTopButton);
			},


		    checkBookSelectable(book) {
                if(!book.finalizedByPublisher){
                    return false;
                }else if (!book.selectable){
                    return false;
                }else{
                    return true;
                }
            },

			async processSearchResults(books) {
				for (const book of books) {
					const cover = await this.getCover(book.pathToCover);
					this.$set(this.imageCache, book.id, cover);
				}
				this.searchResults = books;
			},

			async getCover(pathToCover) {
				const url = utils.reformatBookPath(pathToCover);
				console.log(url);
				return new Promise((resolve) => {
					const img = new Image();
					img.onload = () => resolve(url);
					img.onerror = () => resolve(this.defaultCover);
					img.src = url;
				});
			},


			simpleSearch() {
				document.activeElement.blur();
				this.$store.commit('setLoadingModal', true);
				let reqObj = {
					first : (this.page -1)*9,// bad name but it's used in too many places to change it // paging starts from 0 but the vue component from 1
					pageSize : 9,
					description : this.singleSearch,
					publisherIdList : this.selectedPublisherIdFromFacets,
					bookTypesList : this.selectedBookTypeFromFacets,
					publicationYearList : this.selectedPublicationYearFromFacets,
					finalizedByPublisher: this.finalisedByPublisherFacetSelect,
					active: this.activeFacetSelect,
					pagesFilterMin: null,
					pagesFilterMax: null
				};
				if(this.pagesSelected===true){
					reqObj.pagesFilterMin = this.pages[0];
					reqObj.pagesFilterMax = this.pages[1];
				}
				requests.put('rest/app/search', reqObj, this.searchCallBack);
			},

			searchCallBack(resp) {
				if(resp && resp.facets && this.updateFacets) {
					if (resp.facets['bookType']) {
						this.bookTypeFacets = Object.entries(resp.facets['bookType'])
							.filter(([key, value]) => key !== "epublished" && value > 0)
							.map(([key, value]) => ({key, value}));
					}

					if (resp.facets['bookPublicationYear']) {
						this.publicationYearFacets = Object.entries(resp.facets['bookPublicationYear'])
							.filter(([key, value]) => value > 0)
							.map(([key, value]) => ({key, value}));
					}

					if (resp.facets['bookFinalizedByPublisher']) {
						this.finalisedFacetResultTrue = resp.facets.bookFinalizedByPublisher['true'];
						this.finalisedFacetResultFalse = resp.facets.bookFinalizedByPublisher['false'];
					}

					if (resp.facets['active']) {
						this.activeFacetResultTrue = resp.facets.active['true'];
						this.activeFacetResultFalse = resp.facets.active['false'];
					}

					if (resp.facets['bookPublisherId']) {
						const publisherMap = this.$store.getters.publishersForSelector.publisherMap;

						this.publisherIdFacet = Object.entries(resp.facets['bookPublisherId'])
							.filter(([key, value]) => value > 0)
							.filter(([key]) => publisherMap.hasOwnProperty(key))     // keep only keys that exist in map from DB, solr returns way more
							.map(([key, value]) => ({key, value}));

					}


				}
				this.$store.commit('setLoadingModal', false);
				this.processSearchResults(JSON.parse(JSON.stringify(resp.results)));
				if(resp.results.length===0){
					this.noResults = true;
				}

				this.afterFirstSearch = true;
				// this.page = resp.start+1;
				this.totalPages = Math.floor(resp.total / 9);
				if (resp.total % 9 > 0) {
					this.totalPages++;
				}
			},


			resetSideSearch(){
				if (this.$refs.sideSearch) {
					this.$refs.sideSearch.reset();
				}
				this.finalisedByPublisherFacetSelect = null;
				this.activeFacetSelect = null;
				this.pagesSelected = false;
				this.selectedPublisherIdFromFacets = [];
				this.selectedPublicationYearFromFacets = [];
				this.selectedBookTypeFromFacets = [];
				this.$nextTick(() => {
					this.pages = [1, 3500];
				});
			},
		},


		watch:{
			'page': function(val){
				this.updateFacets = false;
				this.simpleSearch();

			},
			'pagesSelected': function(val){
				document.activeElement.blur();
			},
			'simpleSearchStore': function(val){
				this.resetSideSearch();
				this.searchResults = [];
				this.afterFirstSearch = false;
			},
		},
	}
</script>

<style scoped>
	.col-class {
		font-size: medium;
		font-weight: bold
	}


	.light-grey-outline.v-text-field.v-text-field--outlined >>> fieldset {
		border-color: #DBDBDB;
	}

	.primary-outline.v-text-field.v-text-field--outlined >>> fieldset {
		border-color: #11254D;
	}

	.text-white >>> input {
		color: #DBDBDB !important;
	}

	.text-white >>> label {
		color: #DBDBDB !important;
	}


	.compact-field >>> .v-input__control {
		min-height: 28px !important;
	}

	.compact-field >>> .v-input__slot {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
		margin-bottom: 0 !important;
		min-height: 24px !important;
	}

	/* input in v-text-field text */
	.compact-field >>> input {
		height: 24px !important;
		line-height: 24px !important;
		font-size: 13px !important;
		padding-top: 2px !important;
		padding-bottom: 4px !important;
		margin-top: 2px !important;
		margin-bottom: 0 !important;
	}

	/* Selections inside v-select and v-autocomplete */
	.compact-field >>> .v-select__selections {
		height: 24px !important;
		line-height: 24px !important;
		font-size: 13px !important;
		padding-top: 0 !important; /* fine-tune this value for vertical alignment */
		padding-bottom: 6px !important;
		margin-top: 0 !important;
		margin-bottom: 6px !important;
	}

	/* label positioning */
	.compact-field >>> .v-label {
		top: 2px !important;
		line-height: 24px !important;
		font-size: 13px !important;
	}

	/* dropdown icon (v-icon) vertical alignment */
	.compact-field >>> .v-input__append-inner {
		margin-top: 0 !important;
		height: 24px !important;
		display: flex;
		align-items: center;
	}
	.custom-chip:hover {
		background-color: white !important;
		color: white !important;
		border-color: white !important;
	}

	.checkbox-list {
		max-height: 120px;
		overflow-y: auto;
	}

	/* --- Chrome / Edge --- */
	.checkbox-list::-webkit-scrollbar {
		width: 10px;               /* scrollbar thickness */
	}

	.checkbox-list::-webkit-scrollbar-track {
		background: #cbd1d6;   /* track background */
		border-radius: 9999px;
	}

	.checkbox-list::-webkit-scrollbar-thumb {
		background-color: #11455B; /* Vuetify primary */
		border-radius: 9999px;     /* full pill shape */
		border: 2px solid transparent;
		background-clip: content-box;
	}

	/* hide scrollbar buttons (up/down arrows) */
	.checkbox-list::-webkit-scrollbar-button {
		display: none !important;
		width: 0 !important;
		height: 0 !important;
	}

	.checkbox-list .v-list-item {
		min-height: 28px !important; /* default is ~48px */
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	}

	.checkbox-list .v-input--checkbox {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}

</style>